import { css } from '@emotion/react'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { func, object } from 'prop-types'
import { useSelector } from 'react-redux'
import { CvsFilePicker } from '@components'
import { t } from '@lingui/core/macro'

const paddingTop = css`
  padding-top: 8px;
`

export const GoogleCloud = ({ setUpdatedAccount }) => {
  const features = useSelector(state => state.Auth.features)
  const showOptionalProjectId = features['gcs-projectid'] ?? false

  return (
    <>
      <div>
        <div>{t`This file can be generated in your google cloud account at`}</div>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://console.cloud.google.com/apis/credentials/serviceaccountkey"
        >
          https://console.cloud.google.com/apis/credentials/serviceaccountkey
        </a>
      </div>
      <div css={paddingTop}>
        <CvsFilePicker
          fullWidth
          fileType=".json"
          onChange={file =>
            setUpdatedAccount(old => ({
              ...old,
              metadata: { ...old.metadata, account_key_file: JSON.parse(file) },
            }))
          }
        />
      </div>
      {showOptionalProjectId && (
        <div style={{ marginTop: 12 }}>
          <TextField
            style={{ width: '100%', marginBottom: 12 }}
            variant="outlined"
            label={t`Optional Project ID`}
            onChange={e =>
              setUpdatedAccount(old => ({
                ...old,
                metadata: { ...old.metadata, project_id: e.target.value },
              }))
            }
          />
          <Typography variant="caption">
            {t`Input an optional project id to change output bucket destination`}
          </Typography>
        </div>
      )}
    </>
  )
}

GoogleCloud.propTypes = {
  updatedAccount: object.isRequired,
  setUpdatedAccount: func.isRequired,
}
